import { render, staticRenderFns } from "./Cashier.vue?vue&type=template&id=3b81635e&scoped=true&"
import script from "./Cashier.vue?vue&type=script&lang=js&"
export * from "./Cashier.vue?vue&type=script&lang=js&"
import style0 from "./Cashier.vue?vue&type=style&index=0&id=3b81635e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b81635e",
  null
  
)

export default component.exports